"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Intro() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="intro" className="relative flex min-h-[80vh] items-center justify-center overflow-hidden py-32 !bg-[rgba(224,255,252,1)]">
      <div className="absolute inset-0 bg-[url(https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/bewei-liege-model-1-669f3488.jpg)] bg-cover bg-center opacity-40 pointer-events-none" aria-hidden="true" />

      <div ref={ref} className={`relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <span className="mb-6 font-default font-semibold uppercase tracking-widest text-primary !text-2xl md:mb-8">Das BEWEI BODY Konzept:</span>

        <h1 className="mb-6 font-default text-4xl font-bold tracking-tight !text-[rgba(6,109,84,1)] md:mb-8 md:text-6xl lg:text-7xl">
          Willkommen in Ihrem neuen Körper
        </h1>

        <div className="relative mb-12 md:mb-16"></div>

        <ul className="mb-12 max-w-2xl font-default text-lg leading-relaxed text-muted-foreground md:text-xl list-none p-0 space-y-3">
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Die Reduktion von Fett und Körperumfang</span>
          </li>
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Die Aktivierung des Stoffwechsels</span>
          </li>
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Jüngeres Aussehen &amp; mehr Vitalität</span>
          </li>
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Verbessertes Körperwohlgefühl</span>
          </li>
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Linderung von Arthroseschmerzen</span>
          </li>
          <li className="flex items-center justify-center gap-3 !font-extrabold">
            <Check className="size-5 text-primary shrink-0" />
            <span className="!text-2xl">Besseren Schlaf</span>
          </li>
        </ul>

        <Link href="https://wa.me/491713617469" target="_blank" className="font-medium inline-flex items-center justify-center gap-2 whitespace-nowrap px-10 h-14 rounded-lg text-white text-xl transition-all duration-300 !bg-[rgba(66,130,111,1)] hover:scale-[1.02]">
          Jetzt Probebehandlung buchen!
        </Link>
      </div>
    </section>;
}